<template>
  <div class="ut-container-lg">
    <header class="page-heading">
      <h1>Prospecting</h1>
    </header>
    <prospecting-opportunities v-if="agent.id"
          :gacategory="gacategory"/>
    <prospecting-contact-modal :agentId="agent.id"/>
    <prospecting-follow-up-modal :agentId="agent.id"/>
    <prospecting-appraisal-modal :agentId="agent.id"/>
    <prospecting-remove-prospect-modal :agentId="agent.id" />
    <Prospecting-reconnect-crm-modal :agentId="agent.id" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProspectingOpportunities from '@/views/partials/prospecting/ProspectingOpportunities.vue';
import ProspectingContactModal from '@/components/Modals/ProspectingContactModal.vue';
import ProspectingFollowUpModal from '@/components/Modals/ProspectingFollowUpModal.vue';
import ProspectingAppraisalModal from '@/components/Modals/ProspectingAppraisalModal.vue';
import ProspectingRemoveProspectModal from '@/components/Modals/ProspectingRemoveProspectModal.vue';
import ProspectingReconnectCrmModal from '@/components/Modals/ProspectingReconnectCrmModal.vue';

export default {
  name: 'ProspectingDashboard',
  components: {
    ProspectingOpportunities,
    ProspectingContactModal,
    ProspectingFollowUpModal,
    ProspectingAppraisalModal,
    ProspectingRemoveProspectModal,
    ProspectingReconnectCrmModal,
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
  },
  created() {},
  methods: {
    ...mapActions('prospectsStore', [
      'loadProspectsStats',
      'loadAllTimeProspectsWithStageNew',
    ]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
